import React, { Component } from 'react';

import { withStyles } from "@material-ui/core/styles";
import { connect } from 'react-redux';
import CrudForUserLavoriEseguiti from './crud/LavoriEseguiti/CrudForUserLavoriEseguiti'
import { modelProps } from '../../../model/LavoriEseguiti';

import { styles } from '../../css/commonstyles'




class LavoriEseguiti extends Component {

    constructor(props) {
        super(props);

    }



    render() {

        const { classes } = this.props;

        return (

            <div className={classes.backgroundStylefafafa} >
                <div className={classes.spacingStyle3} >
                    <CrudForUserLavoriEseguiti
                        modelName="LavoriEseguiti"
                        modelNameSingolare="LavoriEseguiti"
                        modelProps={modelProps}
                    />
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {

    }

}

const mapDispatchToProps = (dispatch) => {

    return {


    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(LavoriEseguiti));